import { myReportTemplatesApi } from 'v5/api/report-templates/reportTemplates.api.connected';
import { queryClient } from 'v4/migration/queryClientSingleton';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createReportTemplatesService } from './ReportTemplatesService.impl';

export const myReportTemplatesService = createReportTemplatesService({
  api: myReportTemplatesApi,
  queryClient,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
